import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectRentalCarProtectionTravellerTugo = (state) => state.get('rentalCarProtectionTravellerTugo');

const safeToJS = (val, defaultVal) =>
  (val && typeof val.toJS === 'function' ? val.toJS() : (Array.isArray(val) ? val : defaultVal));

const makeSelectRentalCarProtectionTravellerTugo = () =>
  createSelector(selectRentalCarProtectionTravellerTugo, (state) => ({
    carRentalStartDate: mapWithDefault(state, () => state.getIn(['form', 'carRentalStartDate']), null),
    carRentalEndDate: mapWithDefault(state, () => state.getIn(['form', 'carRentalEndDate']), null),
    pickUpLocation: mapWithDefault(state, () => state.getIn(['form', 'pickUpLocation']), ''),
    dropOffLocation: mapWithDefault(state, () => state.getIn(['form', 'dropOffLocation']), ''),
    nameOfDriver: mapWithDefault(state, () => state.getIn(['form', 'nameOfDriver']), ''),
    authorityToWhomReported: mapWithDefault(state, () => state.getIn(['form', 'authorityToWhomReported']), ''),
    describeAccident: mapWithDefault(state, () => state.getIn(['form', 'describeAccident']), ''),
    causedByAnotherParty: mapWithDefault(state, () => state.getIn(['form', 'causedByAnotherParty']), null),
    responsiblePartyInfo: mapWithDefault(state, () => state.getIn(['form', 'responsiblePartyInfo']), ''),
    rentalCarItems: mapWithDefault(
      state,
      () => safeToJS(state.getIn(['form', 'rentalCarItems']), []),
      []
    ),
  }));

const makeSelectRentalCarProtectionTravellerTugoErrors = () =>
  createSelector(selectRentalCarProtectionTravellerTugo, (state) => state.get('errors'));

export {
  makeSelectRentalCarProtectionTravellerTugo,
  makeSelectRentalCarProtectionTravellerTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.RentalCarProtectionTraveller/selectors.js